/* APP-148: the parts the step, Waiting on others and the Approved confirmation draw alike: the two
   people's avatars, a file's row and its virus check in words. Tokens only. */

/* --- Who: initials in a circle, the Stock Admin's in the info ink -------------------------------- */

.avatar {
  display: grid;
  flex: none;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 2px solid var(--white);
  border-radius: var(--radius-circle);
  background: var(--brand-navy);
  color: var(--white);
  font-size: 13px;
  font-weight: var(--fw-semibold);
}

.avatarActor {
  background: var(--status-info-ink);
}

/* "Recorded as" and "Done by": both people, overlapping by the second's white ring only, so the
   first one's initials stay whole ("MO", never "MC"). */
.pair {
  display: inline-flex;
  flex: none;
}

.pair > .avatar + .avatar {
  margin-left: -4px;
}

/* --- A file: its kind, its name, its size and where it came from, its check ------------------------ */

.files {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.file {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-sm);
}

.fileIcon {
  display: grid;
  flex: none;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  background: var(--brand-cyan-50);
  color: var(--status-info-ink);
}

.fileText {
  display: flex;
  flex: 1 1 200px;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.fileName {
  color: var(--text-heading);
  font-weight: var(--fw-semibold);
  overflow-wrap: anywhere;
}

.fileMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
  align-items: center;
  color: var(--text-secondary);
  font-size: 13px;
}

/* The virus check in words, with its mark: never by colour alone. */
.scan {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  font-weight: var(--fw-semibold);
}

.scanDone {
  color: var(--status-done-ink);
}

.scanWaiting {
  color: var(--status-waiting-ink);
}

.scanProblem {
  color: var(--status-problem-ink);
}
